module.exports = __webpack_public_path__ + "static/media/language-arrow.975bd332.svg";